import { useQuery } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { triggersV2QueryKeys } from "./triggersV2QueryKeys";

/** Every event-driven trigger in the org, in the unified v2 shape. */
export function useTriggersV2(orgId?: string) {
  const { triggerV2Service } = useDomainServices();
  const resolvedOrgId = useCurrentOrgId(orgId);

  return useQuery({
    queryKey: triggersV2QueryKeys.list(resolvedOrgId),
    queryFn: ({ signal }) =>
      triggerV2Service.listTriggers(resolvedOrgId, { abortSignal: signal }),
    staleTime: 30_000,
  });
}
